module.exports = __webpack_public_path__ + "static/media/mid-west.0fda2129.svg";